function columns1() {
	const columns = [{
		title: "员工编码",
		dataIndex: "code",
		key: "code",
		width: 100,
		align: 'center',
		ellipsis: true
	}, {
		title: "员工名称",
		dataIndex: "name",
		key: "name",
		width: 100,
		align: 'center',
		ellipsis: true
	},
	{
		title: "单位名称",
		dataIndex: "company",
		align: 'center',
		key: "company",
		width: 130
	},
	{
		title: "部门名称",
		dataIndex: "dept_name",
		align: 'center',
		width: 130,
		key: "dept_name"
	},
	{
		title: "人员类型",
		dataIndex: "work_nature",
		align: 'center',
		key: "work_nature",
		width: 100
	},
	{
		title: "手机号码",
		dataIndex: "tel_num",
		align: 'center',
		width: 100,
		key: "tel_num"
	},
	{
		title: "身份证号",
		dataIndex: "id_card",
		align: 'center',
		width: 100,
		key: "id_card"
	},
	{
		title: "OA账号",
		dataIndex: "oaNum",
		align: 'center',
		width: 100,
		key: "oaNum"
	},
	{
		title: "应用权限状态",
		dataIndex: "accredit_status",
		key: "accredit_status",
		scopedSlots: { customRender: 'accredit_status' },
		align: 'center',
		width: 100,
	},{
		title: "在职状态",
		dataIndex: "status",
		key: "status",
		align: 'center',
		width: 100,
	},{
		title: "创建时间",
		dataIndex: "create_time",
		key: "create_time",
		align: 'center',
		width: 100,
	}, {
		title: "操作",
		dataIndex: 'operation',
		scopedSlots: { customRender: 'operation' },
		align: "center",
		width: 150,
	},];
	return columns;
};

export {
	columns1
}
